module.exports = __webpack_public_path__ + "img/love.9c5e2f58.svg";